import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const reportData = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '报告名称',
            dataIndex: 'reportName',
            key: 'reportName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.reportName || [],
        },
        {
            title: '分类',
            dataIndex: 'classification',
            key: 'classification',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.classification || [],
        },
        {
            title: '产品经理',
            dataIndex: 'productManager',
            key: 'productManager',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.productManager || [],
        },
        {
            title: '售前对接人-中英文分析方法',
            dataIndex: 'salesContactPerson',
            key: 'salesContactPerson',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesContactPerson || [],
        },
        {
            title: '售后对接人-流程图/常见问题',
            dataIndex: 'afterSalesContactPerson',
            key: 'afterSalesContactPerson',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.afterSalesContactPerson || [],
        },
        {
            title: '是否有交付系统',
            dataIndex: 'hasDeliverySystem',
            key: 'hasDeliverySystem',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.hasDeliverySystem || [],
        },
        {
            title: 'pdf报告',
            dataIndex: 'pdfReport',
            key: 'pdfReport',
            scopedSlots: { customRender: 'pdfReport' }
        },
        {
            title: '网页报告',
            dataIndex: 'webReport',
            key: 'webReport',
            scopedSlots: { customRender: 'webReport' }
        },
        {
            title: '英文分析方法',
            dataIndex: 'englishAnalysisMethod',
            key: 'englishAnalysisMethod',
            scopedSlots: { customRender: 'englishAnalysisMethod' }
        },
        {
            title: '中文分析方法',
            dataIndex: 'chineseAnalysisMethod',
            key: 'chineseAnalysisMethod',
            scopedSlots: { customRender: 'chineseAnalysisMethod' }
        },
        {
            title: '文件更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime'
        }
    ]
}
export const advanced_analysis = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '报告名称',
            dataIndex: 'reportName',
            key: 'reportName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.reportName || [],
        },
        {
            title: '一级分类',
            dataIndex: 'classification',
            key: 'classification',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.classification || [],
        },
        {
            title: '二级分类',
            dataIndex: 'subClassification',
            key: 'subClassification',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.subClassification || [],
        },
        {
            title: '产品经理',
            dataIndex: 'productManager',
            key: 'productManager',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.productManager || [],
        },
        {
            title: 'pdf报告',
            dataIndex: 'pdfReport',
            key: 'pdfReport',
            scopedSlots: { customRender: 'pdfReport' }
        },
        {
            title: '文件更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime'
        }
    ]
}